//@ts-nocheck
// https://github.com/dotansimha/graphql-code-generator-community/pull/329
import { RatingFileCategory as RatingFileType } from '@esgt/types';
import { UserRole as Role } from '@esgt/types';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  admins?: Maybe<Array<Maybe<User>>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  members?: Maybe<Array<Maybe<User>>>;
  orgNumber?: Maybe<Scalars['String']['output']>;
  owner: User;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AccountEligibleRatersResponse = {
  __typename?: 'AccountEligibleRatersResponse';
  users: Array<User>;
};

export type AccountListResult = {
  __typename?: 'AccountListResult';
  id: Scalars['Int']['output'];
  numOfRatings?: Maybe<Scalars['Int']['output']>;
  numOfUsers?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type AggregateCommit = {
  __typename?: 'AggregateCommit';
  aggregateVersion: Scalars['Int']['output'];
  events: Array<Scalars['JSONObject']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type ContactInfo = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContributorGroups = {
  __typename?: 'ContributorGroups';
  contactPerson?: Maybe<User>;
  contributors: Array<User>;
  owner?: Maybe<User>;
  raters: Array<User>;
};

export type DateTimePeriodInput = {
  end: PeriodMonthInput;
  start: PeriodMonthInput;
};

export type DeleteAccountUserInput = {
  accountId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type Method = {
  __typename?: 'Method';
  businessArea: Scalars['String']['output'];
  config: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type MinimalContactInfo = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  abortRating?: Maybe<Scalars['Void']['output']>;
  activateRatingProfileRevision?: Maybe<Scalars['Void']['output']>;
  addAdditionalQuestion?: Maybe<Scalars['Void']['output']>;
  approveAnomaly?: Maybe<Scalars['Void']['output']>;
  approveKpiValue?: Maybe<Scalars['Void']['output']>;
  archiveRatingUpload?: Maybe<Scalars['Void']['output']>;
  archiveRatingUploads?: Maybe<Scalars['Void']['output']>;
  changeRatingContactPersons?: Maybe<Scalars['Void']['output']>;
  changeRatingPeriod?: Maybe<Scalars['Void']['output']>;
  changeRatingProfile?: Maybe<Scalars['Void']['output']>;
  changeRatingRaters?: Maybe<Scalars['Void']['output']>;
  completeFreeRating?: Maybe<Scalars['Void']['output']>;
  completeRating?: Maybe<Scalars['Void']['output']>;
  createAccount?: Maybe<Account>;
  /** RATING PROFILES */
  createRatingProfile: RatingProfile;
  createRatingProfileRevision: RatingProfileRevision;
  createUserInAccount?: Maybe<User>;
  deleteAccount?: Maybe<Account>;
  deleteAccountUser?: Maybe<User>;
  deleteRatingProfileRevision?: Maybe<Scalars['Void']['output']>;
  editRatingComment?: Maybe<Scalars['Void']['output']>;
  editRatingContact?: Maybe<Scalars['Void']['output']>;
  ompostering?: Maybe<Scalars['Void']['output']>;
  orderRating: OrderRatingResult;
  orderSelfServiceRating: OrderRatingResult;
  overrideKpiValue?: Maybe<Scalars['Void']['output']>;
  publishMethod?: Maybe<Scalars['Void']['output']>;
  regenerateReport?: Maybe<Scalars['Void']['output']>;
  removeAdditionalQuestion?: Maybe<Scalars['Void']['output']>;
  removeKpiValueOverride?: Maybe<Scalars['Void']['output']>;
  requestDocumentationAmendments?: Maybe<Scalars['Void']['output']>;
  requestRatingUploadProcessing?: Maybe<Scalars['Void']['output']>;
  setRatingDatapoints?: Maybe<Scalars['Void']['output']>;
  signFileUpload: SignedFileUpload;
  submitDocumentation?: Maybe<Scalars['Void']['output']>;
  unapproveAnomaly?: Maybe<Scalars['Void']['output']>;
  updateAccountUser?: Maybe<User>;
  /** METHOD VERSIONS */
  updateMethod?: Maybe<Scalars['Void']['output']>;
  updateRatingAnswer?: Maybe<Scalars['Void']['output']>;
  updateRatingCompanyText?: Maybe<Scalars['Void']['output']>;
  updateRatingProfileRevisionConfig?: Maybe<Scalars['Void']['output']>;
  upgradeRatingToFull?: Maybe<Scalars['Void']['output']>;
};


export type MutationAbortRatingArgs = {
  ratingId: Scalars['ID']['input'];
};


export type MutationActivateRatingProfileRevisionArgs = {
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
};


export type MutationAddAdditionalQuestionArgs = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  ratingId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  textInput: Scalars['Boolean']['input'];
  uploads: Scalars['Boolean']['input'];
};


export type MutationApproveAnomalyArgs = {
  anomalyId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationApproveKpiValueArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  kpiId: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationArchiveRatingUploadArgs = {
  ratingId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};


export type MutationArchiveRatingUploadsArgs = {
  ratingId: Scalars['ID']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};


export type MutationChangeRatingContactPersonsArgs = {
  addedContacts: Array<MinimalContactInfo>;
  ratingId: Scalars['ID']['input'];
  removedUserIds: Array<Scalars['Int']['input']>;
};


export type MutationChangeRatingPeriodArgs = {
  endMonth: Scalars['Int']['input'];
  endYear: Scalars['Int']['input'];
  ratingId: Scalars['ID']['input'];
  startMonth: Scalars['Int']['input'];
  startYear: Scalars['Int']['input'];
};


export type MutationChangeRatingProfileArgs = {
  ratingId: Scalars['ID']['input'];
  ratingProfileId: Scalars['Int']['input'];
};


export type MutationChangeRatingRatersArgs = {
  raterUserIds: Array<Scalars['Int']['input']>;
  ratingId: Scalars['ID']['input'];
};


export type MutationCompleteFreeRatingArgs = {
  ratingId: Scalars['ID']['input'];
};


export type MutationCompleteRatingArgs = {
  ratingId: Scalars['ID']['input'];
};


export type MutationCreateAccountArgs = {
  input: NewAccountInput;
};


export type MutationCreateRatingProfileArgs = {
  businessArea: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  existingProfileId?: InputMaybe<Scalars['Int']['input']>;
  isBaseline: Scalars['Boolean']['input'];
  methodId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateRatingProfileRevisionArgs = {
  ratingProfileId: Scalars['Int']['input'];
};


export type MutationCreateUserInAccountArgs = {
  input: NewUserInAccountInput;
};


export type MutationDeleteAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationDeleteAccountUserArgs = {
  input: DeleteAccountUserInput;
};


export type MutationDeleteRatingProfileRevisionArgs = {
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
};


export type MutationEditRatingCommentArgs = {
  comment: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationEditRatingContactArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationOmposteringArgs = {
  amount: Scalars['Float']['input'];
  anomalyId: Scalars['String']['input'];
  omposteringsRule: OmposteringsRule;
  ratingId: Scalars['ID']['input'];
};


export type MutationOrderRatingArgs = {
  contactPerson: ContactInfo;
  contributors: Array<MinimalContactInfo>;
  orgNr: Scalars['String']['input'];
  period: DateTimePeriodInput;
  raters: Array<NewRater>;
  ratingProfileId: Scalars['Int']['input'];
};


export type MutationOrderSelfServiceRatingArgs = {
  agreementAccepted: Scalars['Boolean']['input'];
  contactPerson: ContactInfo;
  contributors: Array<MinimalContactInfo>;
  orgNr: Scalars['String']['input'];
  period: DateTimePeriodInput;
  ratingProfileId: Scalars['Int']['input'];
  ratingType: RatingType;
  ratingTypeSelected: RatingType;
};


export type MutationOverrideKpiValueArgs = {
  kpiId: Scalars['String']['input'];
  oldValue?: InputMaybe<Scalars['Float']['input']>;
  ratingId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};


export type MutationPublishMethodArgs = {
  config: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRegenerateReportArgs = {
  ratingId: Scalars['ID']['input'];
};


export type MutationRemoveAdditionalQuestionArgs = {
  id: Scalars['ID']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationRemoveKpiValueOverrideArgs = {
  kpiId: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationRequestDocumentationAmendmentsArgs = {
  message: Scalars['String']['input'];
  ratingId: Scalars['ID']['input'];
  scopes: Array<Scalars['String']['input']>;
};


export type MutationRequestRatingUploadProcessingArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  ratingFileType: RatingFileType;
  ratingId: Scalars['ID']['input'];
  scope: Scalars['String']['input'];
  tempfileKey: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  uploadId: Scalars['ID']['input'];
};


export type MutationSetRatingDatapointsArgs = {
  datapoints: Scalars['JSONObject']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationSubmitDocumentationArgs = {
  ratingId: Scalars['ID']['input'];
};


export type MutationUnapproveAnomalyArgs = {
  anomalyId: Scalars['ID']['input'];
  ratingId: Scalars['ID']['input'];
};


export type MutationUpdateAccountUserArgs = {
  input: UpdateAccountUserInput;
};


export type MutationUpdateMethodArgs = {
  config: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateRatingAnswerArgs = {
  ratingId: Scalars['ID']['input'];
  scope: Scalars['ID']['input'];
  values: Scalars['JSONObject']['input'];
};


export type MutationUpdateRatingCompanyTextArgs = {
  ratingId: Scalars['ID']['input'];
  scope: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationUpdateRatingProfileRevisionConfigArgs = {
  config: Scalars['JSONObject']['input'];
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
};


export type MutationUpgradeRatingToFullArgs = {
  ratingId: Scalars['ID']['input'];
};

export type NewAccountInput = {
  admins: Array<NewUserInput>;
  businessAreas: Array<Scalars['String']['input']>;
  orgNumber: Scalars['String']['input'];
  owner: NewUserInput;
  title: Scalars['String']['input'];
};

export type NewRater = {
  role: UserRatingRole;
  userId: Scalars['Int']['input'];
};

export type NewUserInAccountInput = {
  accountId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: Role;
};

export type NewUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OmposteringsRule = {
  affectedDatapoints: Array<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type OrderRatingResult = {
  __typename?: 'OrderRatingResult';
  commits: Array<AggregateCommit>;
  key: Scalars['ID']['output'];
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum PendingActionBy {
  Customer = 'CUSTOMER',
  None = 'NONE',
  R8Me = 'R8ME'
}

export type PeriodMonthInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountEligibleRaters: AccountEligibleRatersResponse;
  accounts: Array<AccountListResult>;
  currentAccount?: Maybe<Account>;
  currentUser?: Maybe<User>;
  method?: Maybe<Method>;
  methods: Array<Method>;
  rating: Rating;
  ratingContributors: ContributorGroups;
  ratingInstance: RatingInstance;
  ratingProfile?: Maybe<RatingProfile>;
  ratingProfiles: Array<RatingProfileSearchResult>;
  ratingReportHistory: Array<RatingReportVersion>;
  ratingReportUrl?: Maybe<Scalars['String']['output']>;
  userAccounts: Array<AccountListResult>;
  userRatings: Array<Maybe<RatingSearchResult>>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountsArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMethodArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMethodsArgs = {
  businessArea: Scalars['String']['input'];
};


export type QueryRatingArgs = {
  key: Scalars['String']['input'];
};


export type QueryRatingContributorsArgs = {
  key: Scalars['String']['input'];
};


export type QueryRatingInstanceArgs = {
  key: Scalars['String']['input'];
};


export type QueryRatingProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRatingProfilesArgs = {
  businessArea?: InputMaybe<Scalars['String']['input']>;
  methodVersion: Scalars['String']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRatingReportHistoryArgs = {
  key: Scalars['String']['input'];
};


export type QueryRatingReportUrlArgs = {
  key?: InputMaybe<Scalars['ID']['input']>;
  pdfReportKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserRatingsArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type Rating = {
  __typename?: 'Rating';
  accountTitle: Scalars['String']['output'];
  commits: Array<AggregateCommit>;
  key: Scalars['String']['output'];
  owner?: Maybe<User>;
  ratingProfile?: Maybe<RatingProfile>;
  ratingType?: Maybe<RatingType>;
  version: Scalars['Int']['output'];
};

export type RatingCounts = {
  __typename?: 'RatingCounts';
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  free: Scalars['Int']['output'];
  pendingBasis: Scalars['Int']['output'];
  pendingControl: Scalars['Int']['output'];
};

export { RatingFileType };

export type RatingInstance = {
  __typename?: 'RatingInstance';
  key: Scalars['String']['output'];
  state: Scalars['JSONObject']['output'];
  timestamp: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type RatingPeriod = {
  __typename?: 'RatingPeriod';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type RatingProfile = {
  __typename?: 'RatingProfile';
  activeRevision?: Maybe<RatingProfileRevision>;
  activeRevisionId?: Maybe<Scalars['DateTime']['output']>;
  baseline?: Maybe<RatingProfile>;
  businessArea: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isBaseline?: Maybe<Scalars['Boolean']['output']>;
  methodVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revision?: Maybe<RatingProfileRevision>;
  revisionOrActiveRevision?: Maybe<RatingProfileRevision>;
  revisions: Array<RatingProfileRevision>;
};


export type RatingProfileRevisionArgs = {
  revision: Scalars['ID']['input'];
};


export type RatingProfileRevisionOrActiveRevisionArgs = {
  revision?: InputMaybe<Scalars['ID']['input']>;
};

export type RatingProfileRevision = {
  __typename?: 'RatingProfileRevision';
  config?: Maybe<Scalars['JSONObject']['output']>;
  methodId: Scalars['Int']['output'];
  ratingProfileId: Scalars['Int']['output'];
  revision: Scalars['DateTime']['output'];
};

export type RatingProfileSearchResult = {
  __typename?: 'RatingProfileSearchResult';
  activeRevisionId?: Maybe<Scalars['DateTime']['output']>;
  businessArea: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isBaseline?: Maybe<Scalars['Boolean']['output']>;
  latestRevision?: Maybe<Scalars['DateTime']['output']>;
  methodVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revisionCount: Scalars['Int']['output'];
};

export type RatingReportVersion = {
  __typename?: 'RatingReportVersion';
  createdAt: Scalars['DateTime']['output'];
  pdfReportKey: Scalars['String']['output'];
};

export type RatingSearchResult = {
  __typename?: 'RatingSearchResult';
  companyName?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<User>;
  key: Scalars['String']['output'];
  lastSignificantEventAt?: Maybe<Scalars['DateTime']['output']>;
  lastSignificantEventType: Scalars['String']['output'];
  orgNumber?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  pendingActionBy: PendingActionBy;
  period?: Maybe<RatingPeriod>;
  ratingProfile: RatingProfile;
  ratingProfileDescription?: Maybe<Scalars['String']['output']>;
  ratingProfileId: Scalars['Int']['output'];
  ratingType?: Maybe<RatingType>;
  userRole?: Maybe<UserRatingRole>;
};

export enum RatingStateFilter {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Free = 'FREE',
  PendingBasis = 'PENDING_BASIS',
  PendingControl = 'PENDING_CONTROL'
}

export enum RatingType {
  Free = 'FREE',
  Full = 'FULL'
}

export { Role };

export type SignedFileUpload = {
  __typename?: 'SignedFileUpload';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  ratingCommits: Array<AggregateCommit>;
  ratingCounts: RatingCounts;
  ratings: Array<RatingSearchResult>;
};


export type SubscriptionRatingCommitsArgs = {
  key: Scalars['ID']['input'];
  minVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionRatingsArgs = {
  filter?: InputMaybe<RatingStateFilter>;
  pagination?: InputMaybe<PaginationInput>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountUserInput = {
  accountId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
};

export type User = {
  __typename?: 'User';
  access?: Maybe<Array<Maybe<UserAccess>>>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Rating>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  accessTypes: Array<Maybe<Scalars['String']['output']>>;
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
};

export enum UserRatingRole {
  ContactPerson = 'CONTACT_PERSON',
  Contributor = 'CONTRIBUTOR',
  Owner = 'OWNER',
  Rater = 'RATER'
}

export type AbortRatingMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type AbortRatingMutation = { __typename?: 'Mutation', abortRating?: any | null };

export type AccessibleAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessibleAccountsQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', id: number, title?: string | null } | null, accounts: Array<{ __typename?: 'AccountListResult', id: number, title?: string | null }> };

export type CompleteFreeRatingMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type CompleteFreeRatingMutation = { __typename?: 'Mutation', completeFreeRating?: any | null };

export type ArchiveRatingUploadMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
}>;


export type ArchiveRatingUploadMutation = { __typename?: 'Mutation', archiveRatingUpload?: any | null };

export type ArchiveRatingUploadsMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  uploadIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveRatingUploadsMutation = { __typename?: 'Mutation', archiveRatingUploads?: any | null };

export type SignFileUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type SignFileUploadMutation = { __typename?: 'Mutation', signFileUpload: { __typename?: 'SignedFileUpload', id: string, url: string } };

export type RequestRatingUploadProcessingMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  ratingFileType: RatingFileType;
  scope: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  tempfileKey: Scalars['String']['input'];
}>;


export type RequestRatingUploadProcessingMutation = { __typename?: 'Mutation', requestRatingUploadProcessing?: any | null };

export type UpgradeRatingToFullMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type UpgradeRatingToFullMutation = { __typename?: 'Mutation', upgradeRatingToFull?: any | null };

export type RatingReportUrlQueryVariables = Exact<{
  key: Scalars['ID']['input'];
  pdfReportKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type RatingReportUrlQuery = { __typename?: 'Query', ratingReportUrl?: string | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: number, name: string, email: string, phone?: string | null, rating?: { __typename?: 'Rating', key: string, ratingType?: RatingType | null } | null, access?: Array<{ __typename?: 'UserAccess', entityId: string, entityType: string, accessTypes: Array<string | null> } | null> | null } | null, currentAccount?: { __typename?: 'Account', id: number, title?: string | null } | null };

export type RatingAccountQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RatingAccountQuery = { __typename?: 'Query', rating: { __typename?: 'Rating', key: string, accountTitle: string } };

export type RatingInstanceQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RatingInstanceQuery = { __typename?: 'Query', ratingInstance: { __typename?: 'RatingInstance', key: string, version: number, state: any, timestamp: any } };

export type RatingProfileAndRevisionQueryVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RatingProfileAndRevisionQuery = { __typename?: 'Query', ratingProfile?: { __typename?: 'RatingProfile', id: number, description?: string | null, createdAt: any, methodVersion: string, businessArea: string, name: string, baseline?: { __typename?: 'RatingProfile', id: number, activeRevision?: { __typename?: 'RatingProfileRevision', config?: any | null } | null } | null, revisionOrActiveRevision?: { __typename?: 'RatingProfileRevision', revision: any, config?: any | null, methodId: number } | null } | null };

export type RatingProviderSubscriptionSubscriptionVariables = Exact<{
  key: Scalars['ID']['input'];
  minVersion: Scalars['Int']['input'];
}>;


export type RatingProviderSubscriptionSubscription = { __typename?: 'Subscription', ratingCommits: Array<{ __typename?: 'AggregateCommit', aggregateVersion: number, timestamp: any, events: Array<any> }> };

export type AccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: number, title?: string | null, orgNumber?: string | null, owner: { __typename?: 'User', id: number, name: string, email: string, phone?: string | null }, admins?: Array<{ __typename?: 'User', id: number, name: string, email: string, phone?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id: number, name: string, email: string, phone?: string | null } | null> | null } };

export type DeleteAccountUserMutationVariables = Exact<{
  input: DeleteAccountUserInput;
}>;


export type DeleteAccountUserMutation = { __typename?: 'Mutation', deleteAccountUser?: { __typename?: 'User', deletedAt?: string | null } | null };

export type CreateUserInAccountMutationVariables = Exact<{
  input: NewUserInAccountInput;
}>;


export type CreateUserInAccountMutation = { __typename?: 'Mutation', createUserInAccount?: { __typename?: 'User', id: number } | null };

export type UpdateAccountUserMutationVariables = Exact<{
  input: UpdateAccountUserInput;
}>;


export type UpdateAccountUserMutation = { __typename?: 'Mutation', updateAccountUser?: { __typename?: 'User', id: number } | null };

export type DeleteAccountMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'Account', deletedAt?: any | null } | null };

export type CreateNewAccountMutationVariables = Exact<{
  input: NewAccountInput;
}>;


export type CreateNewAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'Account', id: number } | null };

export type AccountsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'AccountListResult', id: number, title?: string | null, numOfUsers?: number | null, numOfRatings?: number | null }> };

export type UserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename?: 'AccountListResult', id: number, title?: string | null, numOfRatings?: number | null, userRole?: string | null }> };

export type MethodsQueryVariables = Exact<{
  businessArea: Scalars['String']['input'];
}>;


export type MethodsQuery = { __typename?: 'Query', methods: Array<{ __typename?: 'Method', id: number, version: string, name: string, description: string, isPublished: boolean, businessArea: string, config: any, createdAt: any, updatedAt: any }> };

export type MethodQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MethodQuery = { __typename?: 'Query', method?: { __typename?: 'Method', id: number, version: string, name: string, description: string, isPublished: boolean, businessArea: string, config: any, createdAt: any, updatedAt: any } | null };

export type OrderSelfServiceRatingMutationVariables = Exact<{
  orgNr: Scalars['String']['input'];
  contactPerson: ContactInfo;
  period: DateTimePeriodInput;
  ratingProfileId: Scalars['Int']['input'];
  ratingType: RatingType;
  contributors: Array<MinimalContactInfo> | MinimalContactInfo;
  ratingTypeSelected: RatingType;
  agreementAccepted: Scalars['Boolean']['input'];
}>;


export type OrderSelfServiceRatingMutation = { __typename?: 'Mutation', orderSelfServiceRating: { __typename?: 'OrderRatingResult', key: string, commits: Array<{ __typename?: 'AggregateCommit', aggregateVersion: number, events: Array<any> }> } };

export type UserRatingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRatingsQuery = { __typename?: 'Query', userRatings: Array<{ __typename?: 'RatingSearchResult', key: string, companyName?: string | null, lastSignificantEventType: string, ratingType?: RatingType | null, userRole?: UserRatingRole | null, period?: { __typename?: 'RatingPeriod', start: any, end: any } | null } | null> };

export type UpdateRatingCompanyTextMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  scope: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateRatingCompanyTextMutation = { __typename?: 'Mutation', updateRatingCompanyText?: any | null };

export type UpdateRatingAnswerMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  scope: Scalars['ID']['input'];
  values: Scalars['JSONObject']['input'];
}>;


export type UpdateRatingAnswerMutation = { __typename?: 'Mutation', updateRatingAnswer?: any | null };

export type SubmitDocumentationMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type SubmitDocumentationMutation = { __typename?: 'Mutation', submitDocumentation?: any | null };

export type MethodsForRatingProfileCreationQueryVariables = Exact<{
  businessArea: Scalars['String']['input'];
}>;


export type MethodsForRatingProfileCreationQuery = { __typename?: 'Query', methods: Array<{ __typename?: 'Method', id: number, version: string, name: string, description: string }> };

export type NewRatingProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  methodId: Scalars['Int']['input'];
  businessArea: Scalars['String']['input'];
  isBaseline: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  existingProfileId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NewRatingProfileMutation = { __typename?: 'Mutation', createRatingProfile: { __typename?: 'RatingProfile', id: number } };

export type RatingProfilesQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  businessArea?: InputMaybe<Scalars['String']['input']>;
  methodVersion: Scalars['String']['input'];
}>;


export type RatingProfilesQuery = { __typename?: 'Query', ratingProfiles: Array<{ __typename?: 'RatingProfileSearchResult', id: number, name: string, description?: string | null, revisionCount: number, latestRevision?: any | null, activeRevisionId?: any | null, businessArea: string, methodVersion: string, isBaseline?: boolean | null }> };

export type RatingProfileQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RatingProfileQuery = { __typename?: 'Query', ratingProfile?: { __typename?: 'RatingProfile', id: number, description?: string | null, activeRevisionId?: any | null, createdAt: any, name: string, revisions: Array<{ __typename?: 'RatingProfileRevision', revision: any, config?: any | null }> } | null };

export type CreateRatingProfileRevisionMutationVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
}>;


export type CreateRatingProfileRevisionMutation = { __typename?: 'Mutation', createRatingProfileRevision: { __typename?: 'RatingProfileRevision', revision: any } };

export type ActivateRatingProfileRevisionMutationVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
}>;


export type ActivateRatingProfileRevisionMutation = { __typename?: 'Mutation', activateRatingProfileRevision?: any | null };

export type DeleteRatingProfileRevisionMutationVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
}>;


export type DeleteRatingProfileRevisionMutation = { __typename?: 'Mutation', deleteRatingProfileRevision?: any | null };

export type RatingProfileRevisionQueryVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['ID']['input'];
}>;


export type RatingProfileRevisionQuery = { __typename?: 'Query', ratingProfile?: { __typename?: 'RatingProfile', id: number, activeRevisionId?: any | null, methodVersion: string, businessArea: string, name: string, isBaseline?: boolean | null, revision?: { __typename?: 'RatingProfileRevision', revision: any, config?: any | null, methodId: number } | null, baseline?: { __typename?: 'RatingProfile', id: number, activeRevision?: { __typename?: 'RatingProfileRevision', revision: any, config?: any | null } | null } | null } | null };

export type UpdateRatingProfileRevisionConfigMutationVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
  revision: Scalars['DateTime']['input'];
  config: Scalars['JSONObject']['input'];
}>;


export type UpdateRatingProfileRevisionConfigMutation = { __typename?: 'Mutation', updateRatingProfileRevisionConfig?: any | null };

export type OrderRatingMutationVariables = Exact<{
  orgNr: Scalars['String']['input'];
  contactPerson: ContactInfo;
  period: DateTimePeriodInput;
  ratingProfileId: Scalars['Int']['input'];
  raters: Array<NewRater> | NewRater;
  contributors: Array<MinimalContactInfo> | MinimalContactInfo;
}>;


export type OrderRatingMutation = { __typename?: 'Mutation', orderRating: { __typename?: 'OrderRatingResult', key: string, commits: Array<{ __typename?: 'AggregateCommit', aggregateVersion: number, events: Array<any> }> } };

export type AccountEligibleRatersQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountEligibleRatersQuery = { __typename?: 'Query', accountEligibleRaters: { __typename?: 'AccountEligibleRatersResponse', users: Array<{ __typename?: 'User', id: number, name: string, email: string, phone?: string | null }> } };

export type RatingProfileNameAndDescriptionByIdQueryVariables = Exact<{
  ratingProfileId: Scalars['Int']['input'];
}>;


export type RatingProfileNameAndDescriptionByIdQuery = { __typename?: 'Query', ratingProfile?: { __typename?: 'RatingProfile', id: number, name: string, description?: string | null } | null };

export type RatingsOverviewSubscriptionVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RatingStateFilter>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type RatingsOverviewSubscription = { __typename?: 'Subscription', ratings: Array<{ __typename?: 'RatingSearchResult', companyName?: string | null, orgNumber?: string | null, key: string, ratingProfileId: number, ratingProfileDescription?: string | null, lastSignificantEventType: string, lastSignificantEventAt?: any | null, pendingActionBy: PendingActionBy, contactPerson?: { __typename?: 'User', id: number, name: string } | null, period?: { __typename?: 'RatingPeriod', start: any, end: any } | null, ratingProfile: { __typename?: 'RatingProfile', id: number, name: string, businessArea: string, methodVersion: string }, owner?: { __typename?: 'User', id: number, name: string } | null }> };

export type RatingCountsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RatingCountsSubscription = { __typename?: 'Subscription', ratingCounts: { __typename?: 'RatingCounts', pendingBasis: number, pendingControl: number, completed: number, cancelled: number, free: number } };

export type ApproveAnomalyMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  anomalyId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
}>;


export type ApproveAnomalyMutation = { __typename?: 'Mutation', approveAnomaly?: any | null };

export type UnapproveAnomalyMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  anomalyId: Scalars['ID']['input'];
}>;


export type UnapproveAnomalyMutation = { __typename?: 'Mutation', unapproveAnomaly?: any | null };

export type OmposteringMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  anomalyId: Scalars['String']['input'];
  omposteringsRule: OmposteringsRule;
}>;


export type OmposteringMutation = { __typename?: 'Mutation', ompostering?: any | null };

export type RemoveAdditionalQuestionMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveAdditionalQuestionMutation = { __typename?: 'Mutation', removeAdditionalQuestion?: any | null };

export type AddAdditionalQuestionMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  helpText?: InputMaybe<Scalars['String']['input']>;
  textInput: Scalars['Boolean']['input'];
  uploads: Scalars['Boolean']['input'];
}>;


export type AddAdditionalQuestionMutation = { __typename?: 'Mutation', addAdditionalQuestion?: any | null };

export type RequestDocumentationAmendmentsMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RequestDocumentationAmendmentsMutation = { __typename?: 'Mutation', requestDocumentationAmendments?: any | null };

export type CompleteRatingMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type CompleteRatingMutation = { __typename?: 'Mutation', completeRating?: any | null };

export type EditRatingCommentMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
}>;


export type EditRatingCommentMutation = { __typename?: 'Mutation', editRatingComment?: any | null };

export type ApproveKpiValueMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  kpiId: Scalars['String']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ApproveKpiValueMutation = { __typename?: 'Mutation', approveKpiValue?: any | null };

export type SetRatingDatapointsMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  datapoints: Scalars['JSONObject']['input'];
}>;


export type SetRatingDatapointsMutation = { __typename?: 'Mutation', setRatingDatapoints?: any | null };

export type OverrideKpiValueMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  kpiId: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  oldValue?: InputMaybe<Scalars['Float']['input']>;
  reason: Scalars['String']['input'];
}>;


export type OverrideKpiValueMutation = { __typename?: 'Mutation', overrideKpiValue?: any | null };

export type RemoveKpiValueOverrideMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  kpiId: Scalars['String']['input'];
}>;


export type RemoveKpiValueOverrideMutation = { __typename?: 'Mutation', removeKpiValueOverride?: any | null };

export type RatingCommitsQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RatingCommitsQuery = { __typename?: 'Query', rating: { __typename?: 'Rating', key: string, commits: Array<{ __typename?: 'AggregateCommit', aggregateVersion: number, timestamp: any, events: Array<any> }> } };

export type ChangeRatingPeriodMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  startYear: Scalars['Int']['input'];
  startMonth: Scalars['Int']['input'];
  endYear: Scalars['Int']['input'];
  endMonth: Scalars['Int']['input'];
}>;


export type ChangeRatingPeriodMutation = { __typename?: 'Mutation', changeRatingPeriod?: any | null };

export type ChangeRatingProfileMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  ratingProfileId: Scalars['Int']['input'];
}>;


export type ChangeRatingProfileMutation = { __typename?: 'Mutation', changeRatingProfile?: any | null };

export type EditRatingContactMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type EditRatingContactMutation = { __typename?: 'Mutation', editRatingContact?: any | null };

export type RatingContributorsQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RatingContributorsQuery = { __typename?: 'Query', ratingContributors: { __typename?: 'ContributorGroups', owner?: { __typename?: 'User', id: number, name: string, email: string, phone?: string | null } | null, raters: Array<{ __typename?: 'User', id: number, name: string, email: string, phone?: string | null }>, contributors: Array<{ __typename?: 'User', id: number, name: string, email: string, phone?: string | null }>, contactPerson?: { __typename?: 'User', id: number, name: string, email: string, phone?: string | null } | null } };

export type ChangeRatingRatersMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  raterUserIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ChangeRatingRatersMutation = { __typename?: 'Mutation', changeRatingRaters?: any | null };

export type ChangeRatingContactPersonsMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
  removedUserIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  addedContacts: Array<MinimalContactInfo> | MinimalContactInfo;
}>;


export type ChangeRatingContactPersonsMutation = { __typename?: 'Mutation', changeRatingContactPersons?: any | null };

export type RatingReportHistoryQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RatingReportHistoryQuery = { __typename?: 'Query', ratingReportHistory: Array<{ __typename?: 'RatingReportVersion', pdfReportKey: string, createdAt: any }> };

export type RegenerateReportMutationVariables = Exact<{
  ratingId: Scalars['ID']['input'];
}>;


export type RegenerateReportMutation = { __typename?: 'Mutation', regenerateReport?: any | null };


export const AbortRatingDocument = /*#__PURE__*/ gql`
    mutation AbortRating($ratingId: ID!) {
  abortRating(ratingId: $ratingId)
}
    `;

export function useAbortRatingMutation() {
  return Urql.useMutation<AbortRatingMutation, AbortRatingMutationVariables>(AbortRatingDocument);
};
export const AccessibleAccountsDocument = /*#__PURE__*/ gql`
    query AccessibleAccounts {
  currentAccount {
    id
    title
  }
  accounts {
    id
    title
  }
}
    `;

export function useAccessibleAccountsQuery(options?: Omit<Urql.UseQueryArgs<AccessibleAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<AccessibleAccountsQuery, AccessibleAccountsQueryVariables>({ query: AccessibleAccountsDocument, ...options });
};
export const CompleteFreeRatingDocument = /*#__PURE__*/ gql`
    mutation CompleteFreeRating($ratingId: ID!) {
  completeFreeRating(ratingId: $ratingId)
}
    `;

export function useCompleteFreeRatingMutation() {
  return Urql.useMutation<CompleteFreeRatingMutation, CompleteFreeRatingMutationVariables>(CompleteFreeRatingDocument);
};
export const ArchiveRatingUploadDocument = /*#__PURE__*/ gql`
    mutation ArchiveRatingUpload($ratingId: ID!, $uploadId: ID!) {
  archiveRatingUpload(ratingId: $ratingId, uploadId: $uploadId)
}
    `;

export function useArchiveRatingUploadMutation() {
  return Urql.useMutation<ArchiveRatingUploadMutation, ArchiveRatingUploadMutationVariables>(ArchiveRatingUploadDocument);
};
export const ArchiveRatingUploadsDocument = /*#__PURE__*/ gql`
    mutation ArchiveRatingUploads($ratingId: ID!, $uploadIds: [ID!]!) {
  archiveRatingUploads(ratingId: $ratingId, uploadIds: $uploadIds)
}
    `;

export function useArchiveRatingUploadsMutation() {
  return Urql.useMutation<ArchiveRatingUploadsMutation, ArchiveRatingUploadsMutationVariables>(ArchiveRatingUploadsDocument);
};
export const SignFileUploadDocument = /*#__PURE__*/ gql`
    mutation SignFileUpload {
  signFileUpload {
    id
    url
  }
}
    `;

export function useSignFileUploadMutation() {
  return Urql.useMutation<SignFileUploadMutation, SignFileUploadMutationVariables>(SignFileUploadDocument);
};
export const RequestRatingUploadProcessingDocument = /*#__PURE__*/ gql`
    mutation RequestRatingUploadProcessing($ratingId: ID!, $uploadId: ID!, $filename: String!, $contentType: String, $ratingFileType: RatingFileType!, $scope: String!, $timestamp: DateTime!, $tempfileKey: String!) {
  requestRatingUploadProcessing(
    ratingId: $ratingId
    uploadId: $uploadId
    filename: $filename
    contentType: $contentType
    ratingFileType: $ratingFileType
    scope: $scope
    timestamp: $timestamp
    tempfileKey: $tempfileKey
  )
}
    `;

export function useRequestRatingUploadProcessingMutation() {
  return Urql.useMutation<RequestRatingUploadProcessingMutation, RequestRatingUploadProcessingMutationVariables>(RequestRatingUploadProcessingDocument);
};
export const UpgradeRatingToFullDocument = /*#__PURE__*/ gql`
    mutation UpgradeRatingToFull($ratingId: ID!) {
  upgradeRatingToFull(ratingId: $ratingId)
}
    `;

export function useUpgradeRatingToFullMutation() {
  return Urql.useMutation<UpgradeRatingToFullMutation, UpgradeRatingToFullMutationVariables>(UpgradeRatingToFullDocument);
};
export const RatingReportUrlDocument = /*#__PURE__*/ gql`
    query RatingReportUrl($key: ID!, $pdfReportKey: String) {
  ratingReportUrl(key: $key, pdfReportKey: $pdfReportKey)
}
    `;

export function useRatingReportUrlQuery(options: Omit<Urql.UseQueryArgs<RatingReportUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingReportUrlQuery, RatingReportUrlQueryVariables>({ query: RatingReportUrlDocument, ...options });
};
export const CurrentUserDocument = /*#__PURE__*/ gql`
    query CurrentUser {
  currentUser {
    id
    name
    email
    phone
    rating {
      key
      ratingType
    }
    access {
      entityId
      entityType
      accessTypes
    }
  }
  currentAccount {
    id
    title
  }
}
    `;

export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({ query: CurrentUserDocument, ...options });
};
export const RatingAccountDocument = /*#__PURE__*/ gql`
    query RatingAccount($key: String!) {
  rating(key: $key) {
    key
    accountTitle
  }
}
    `;

export function useRatingAccountQuery(options: Omit<Urql.UseQueryArgs<RatingAccountQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingAccountQuery, RatingAccountQueryVariables>({ query: RatingAccountDocument, ...options });
};
export const RatingInstanceDocument = /*#__PURE__*/ gql`
    query RatingInstance($key: String!) {
  ratingInstance(key: $key) {
    key
    version
    state
    timestamp
  }
}
    `;

export function useRatingInstanceQuery(options: Omit<Urql.UseQueryArgs<RatingInstanceQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingInstanceQuery, RatingInstanceQueryVariables>({ query: RatingInstanceDocument, ...options });
};
export const RatingProfileAndRevisionDocument = /*#__PURE__*/ gql`
    query RatingProfileAndRevision($ratingProfileId: Int!, $revision: ID) {
  ratingProfile(id: $ratingProfileId) {
    id
    description
    createdAt
    methodVersion
    businessArea
    name
    baseline {
      id
      activeRevision {
        config
      }
    }
    revisionOrActiveRevision(revision: $revision) {
      revision
      config
      methodId
    }
  }
}
    `;

export function useRatingProfileAndRevisionQuery(options: Omit<Urql.UseQueryArgs<RatingProfileAndRevisionQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingProfileAndRevisionQuery, RatingProfileAndRevisionQueryVariables>({ query: RatingProfileAndRevisionDocument, ...options });
};
export const RatingProviderSubscriptionDocument = /*#__PURE__*/ gql`
    subscription RatingProviderSubscription($key: ID!, $minVersion: Int!) {
  ratingCommits(key: $key, minVersion: $minVersion) {
    aggregateVersion
    timestamp
    events
  }
}
    `;

export function useRatingProviderSubscriptionSubscription<TData = RatingProviderSubscriptionSubscription>(options: Omit<Urql.UseSubscriptionArgs<RatingProviderSubscriptionSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<RatingProviderSubscriptionSubscription, TData>) {
  return Urql.useSubscription<RatingProviderSubscriptionSubscription, TData, RatingProviderSubscriptionSubscriptionVariables>({ query: RatingProviderSubscriptionDocument, ...options }, handler);
};
export const AccountDocument = /*#__PURE__*/ gql`
    query Account($id: ID!) {
  account(id: $id) {
    id
    title
    orgNumber
    owner {
      id
      name
      email
      phone
    }
    admins {
      id
      name
      email
      phone
    }
    members {
      id
      name
      email
      phone
    }
  }
}
    `;

export function useAccountQuery(options: Omit<Urql.UseQueryArgs<AccountQueryVariables>, 'query'>) {
  return Urql.useQuery<AccountQuery, AccountQueryVariables>({ query: AccountDocument, ...options });
};
export const DeleteAccountUserDocument = /*#__PURE__*/ gql`
    mutation DeleteAccountUser($input: DeleteAccountUserInput!) {
  deleteAccountUser(input: $input) {
    deletedAt
  }
}
    `;

export function useDeleteAccountUserMutation() {
  return Urql.useMutation<DeleteAccountUserMutation, DeleteAccountUserMutationVariables>(DeleteAccountUserDocument);
};
export const CreateUserInAccountDocument = /*#__PURE__*/ gql`
    mutation CreateUserInAccount($input: NewUserInAccountInput!) {
  createUserInAccount(input: $input) {
    id
  }
}
    `;

export function useCreateUserInAccountMutation() {
  return Urql.useMutation<CreateUserInAccountMutation, CreateUserInAccountMutationVariables>(CreateUserInAccountDocument);
};
export const UpdateAccountUserDocument = /*#__PURE__*/ gql`
    mutation UpdateAccountUser($input: UpdateAccountUserInput!) {
  updateAccountUser(input: $input) {
    id
  }
}
    `;

export function useUpdateAccountUserMutation() {
  return Urql.useMutation<UpdateAccountUserMutation, UpdateAccountUserMutationVariables>(UpdateAccountUserDocument);
};
export const DeleteAccountDocument = /*#__PURE__*/ gql`
    mutation DeleteAccount($accountId: Int!) {
  deleteAccount(accountId: $accountId) {
    deletedAt
  }
}
    `;

export function useDeleteAccountMutation() {
  return Urql.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument);
};
export const CreateNewAccountDocument = /*#__PURE__*/ gql`
    mutation CreateNewAccount($input: NewAccountInput!) {
  createAccount(input: $input) {
    id
  }
}
    `;

export function useCreateNewAccountMutation() {
  return Urql.useMutation<CreateNewAccountMutation, CreateNewAccountMutationVariables>(CreateNewAccountDocument);
};
export const AccountsDocument = /*#__PURE__*/ gql`
    query Accounts($q: String) {
  accounts(q: $q) {
    id
    title
    numOfUsers
    numOfRatings
  }
}
    `;

export function useAccountsQuery(options?: Omit<Urql.UseQueryArgs<AccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<AccountsQuery, AccountsQueryVariables>({ query: AccountsDocument, ...options });
};
export const UserAccountsDocument = /*#__PURE__*/ gql`
    query UserAccounts {
  userAccounts {
    id
    title
    numOfRatings
    userRole
  }
}
    `;

export function useUserAccountsQuery(options?: Omit<Urql.UseQueryArgs<UserAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserAccountsQuery, UserAccountsQueryVariables>({ query: UserAccountsDocument, ...options });
};
export const MethodsDocument = /*#__PURE__*/ gql`
    query Methods($businessArea: String!) {
  methods(businessArea: $businessArea) {
    id
    version
    name
    description
    isPublished
    businessArea
    config
    createdAt
    updatedAt
  }
}
    `;

export function useMethodsQuery(options: Omit<Urql.UseQueryArgs<MethodsQueryVariables>, 'query'>) {
  return Urql.useQuery<MethodsQuery, MethodsQueryVariables>({ query: MethodsDocument, ...options });
};
export const MethodDocument = /*#__PURE__*/ gql`
    query Method($id: Int!) {
  method(id: $id) {
    id
    version
    name
    description
    isPublished
    businessArea
    config
    createdAt
    updatedAt
  }
}
    `;

export function useMethodQuery(options: Omit<Urql.UseQueryArgs<MethodQueryVariables>, 'query'>) {
  return Urql.useQuery<MethodQuery, MethodQueryVariables>({ query: MethodDocument, ...options });
};
export const OrderSelfServiceRatingDocument = /*#__PURE__*/ gql`
    mutation OrderSelfServiceRating($orgNr: String!, $contactPerson: ContactInfo!, $period: DateTimePeriodInput!, $ratingProfileId: Int!, $ratingType: RatingType!, $contributors: [MinimalContactInfo!]!, $ratingTypeSelected: RatingType!, $agreementAccepted: Boolean!) {
  orderSelfServiceRating(
    orgNr: $orgNr
    contactPerson: $contactPerson
    period: $period
    ratingProfileId: $ratingProfileId
    ratingType: $ratingType
    contributors: $contributors
    ratingTypeSelected: $ratingTypeSelected
    agreementAccepted: $agreementAccepted
  ) {
    key
    commits {
      aggregateVersion
      events
    }
  }
}
    `;

export function useOrderSelfServiceRatingMutation() {
  return Urql.useMutation<OrderSelfServiceRatingMutation, OrderSelfServiceRatingMutationVariables>(OrderSelfServiceRatingDocument);
};
export const UserRatingsDocument = /*#__PURE__*/ gql`
    query UserRatings {
  userRatings {
    key
    companyName
    lastSignificantEventType
    period {
      start
      end
    }
    ratingType
    userRole
  }
}
    `;

export function useUserRatingsQuery(options?: Omit<Urql.UseQueryArgs<UserRatingsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserRatingsQuery, UserRatingsQueryVariables>({ query: UserRatingsDocument, ...options });
};
export const UpdateRatingCompanyTextDocument = /*#__PURE__*/ gql`
    mutation UpdateRatingCompanyText($ratingId: ID!, $scope: ID!, $text: String!) {
  updateRatingCompanyText(ratingId: $ratingId, scope: $scope, text: $text)
}
    `;

export function useUpdateRatingCompanyTextMutation() {
  return Urql.useMutation<UpdateRatingCompanyTextMutation, UpdateRatingCompanyTextMutationVariables>(UpdateRatingCompanyTextDocument);
};
export const UpdateRatingAnswerDocument = /*#__PURE__*/ gql`
    mutation UpdateRatingAnswer($ratingId: ID!, $scope: ID!, $values: JSONObject!) {
  updateRatingAnswer(ratingId: $ratingId, scope: $scope, values: $values)
}
    `;

export function useUpdateRatingAnswerMutation() {
  return Urql.useMutation<UpdateRatingAnswerMutation, UpdateRatingAnswerMutationVariables>(UpdateRatingAnswerDocument);
};
export const SubmitDocumentationDocument = /*#__PURE__*/ gql`
    mutation SubmitDocumentation($ratingId: ID!) {
  submitDocumentation(ratingId: $ratingId)
}
    `;

export function useSubmitDocumentationMutation() {
  return Urql.useMutation<SubmitDocumentationMutation, SubmitDocumentationMutationVariables>(SubmitDocumentationDocument);
};
export const MethodsForRatingProfileCreationDocument = /*#__PURE__*/ gql`
    query MethodsForRatingProfileCreation($businessArea: String!) {
  methods(businessArea: $businessArea) {
    id
    version
    name
    description
  }
}
    `;

export function useMethodsForRatingProfileCreationQuery(options: Omit<Urql.UseQueryArgs<MethodsForRatingProfileCreationQueryVariables>, 'query'>) {
  return Urql.useQuery<MethodsForRatingProfileCreationQuery, MethodsForRatingProfileCreationQueryVariables>({ query: MethodsForRatingProfileCreationDocument, ...options });
};
export const NewRatingProfileDocument = /*#__PURE__*/ gql`
    mutation NewRatingProfile($name: String!, $methodId: Int!, $businessArea: String!, $isBaseline: Boolean!, $description: String, $existingProfileId: Int) {
  createRatingProfile(
    name: $name
    methodId: $methodId
    businessArea: $businessArea
    description: $description
    isBaseline: $isBaseline
    existingProfileId: $existingProfileId
  ) {
    id
  }
}
    `;

export function useNewRatingProfileMutation() {
  return Urql.useMutation<NewRatingProfileMutation, NewRatingProfileMutationVariables>(NewRatingProfileDocument);
};
export const RatingProfilesDocument = /*#__PURE__*/ gql`
    query RatingProfiles($q: String, $businessArea: String, $methodVersion: String!) {
  ratingProfiles(
    q: $q
    businessArea: $businessArea
    methodVersion: $methodVersion
  ) {
    id
    name
    description
    revisionCount
    latestRevision
    activeRevisionId
    businessArea
    methodVersion
    isBaseline
  }
}
    `;

export function useRatingProfilesQuery(options: Omit<Urql.UseQueryArgs<RatingProfilesQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingProfilesQuery, RatingProfilesQueryVariables>({ query: RatingProfilesDocument, ...options });
};
export const RatingProfileDocument = /*#__PURE__*/ gql`
    query RatingProfile($id: Int!) {
  ratingProfile(id: $id) {
    id
    description
    activeRevisionId
    createdAt
    name
    revisions {
      revision
      config
    }
  }
}
    `;

export function useRatingProfileQuery(options: Omit<Urql.UseQueryArgs<RatingProfileQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingProfileQuery, RatingProfileQueryVariables>({ query: RatingProfileDocument, ...options });
};
export const CreateRatingProfileRevisionDocument = /*#__PURE__*/ gql`
    mutation CreateRatingProfileRevision($ratingProfileId: Int!) {
  createRatingProfileRevision(ratingProfileId: $ratingProfileId) {
    revision
  }
}
    `;

export function useCreateRatingProfileRevisionMutation() {
  return Urql.useMutation<CreateRatingProfileRevisionMutation, CreateRatingProfileRevisionMutationVariables>(CreateRatingProfileRevisionDocument);
};
export const ActivateRatingProfileRevisionDocument = /*#__PURE__*/ gql`
    mutation ActivateRatingProfileRevision($ratingProfileId: Int!, $revision: DateTime!) {
  activateRatingProfileRevision(
    ratingProfileId: $ratingProfileId
    revision: $revision
  )
}
    `;

export function useActivateRatingProfileRevisionMutation() {
  return Urql.useMutation<ActivateRatingProfileRevisionMutation, ActivateRatingProfileRevisionMutationVariables>(ActivateRatingProfileRevisionDocument);
};
export const DeleteRatingProfileRevisionDocument = /*#__PURE__*/ gql`
    mutation DeleteRatingProfileRevision($ratingProfileId: Int!, $revision: DateTime!) {
  deleteRatingProfileRevision(
    ratingProfileId: $ratingProfileId
    revision: $revision
  )
}
    `;

export function useDeleteRatingProfileRevisionMutation() {
  return Urql.useMutation<DeleteRatingProfileRevisionMutation, DeleteRatingProfileRevisionMutationVariables>(DeleteRatingProfileRevisionDocument);
};
export const RatingProfileRevisionDocument = /*#__PURE__*/ gql`
    query RatingProfileRevision($ratingProfileId: Int!, $revision: ID!) {
  ratingProfile(id: $ratingProfileId) {
    id
    activeRevisionId
    methodVersion
    businessArea
    name
    isBaseline
    revision(revision: $revision) {
      revision
      config
      methodId
    }
    baseline {
      id
      activeRevision {
        revision
        config
      }
    }
  }
}
    `;

export function useRatingProfileRevisionQuery(options: Omit<Urql.UseQueryArgs<RatingProfileRevisionQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingProfileRevisionQuery, RatingProfileRevisionQueryVariables>({ query: RatingProfileRevisionDocument, ...options });
};
export const UpdateRatingProfileRevisionConfigDocument = /*#__PURE__*/ gql`
    mutation UpdateRatingProfileRevisionConfig($ratingProfileId: Int!, $revision: DateTime!, $config: JSONObject!) {
  updateRatingProfileRevisionConfig(
    ratingProfileId: $ratingProfileId
    revision: $revision
    config: $config
  )
}
    `;

export function useUpdateRatingProfileRevisionConfigMutation() {
  return Urql.useMutation<UpdateRatingProfileRevisionConfigMutation, UpdateRatingProfileRevisionConfigMutationVariables>(UpdateRatingProfileRevisionConfigDocument);
};
export const OrderRatingDocument = /*#__PURE__*/ gql`
    mutation OrderRating($orgNr: String!, $contactPerson: ContactInfo!, $period: DateTimePeriodInput!, $ratingProfileId: Int!, $raters: [NewRater!]!, $contributors: [MinimalContactInfo!]!) {
  orderRating(
    orgNr: $orgNr
    contactPerson: $contactPerson
    period: $period
    ratingProfileId: $ratingProfileId
    raters: $raters
    contributors: $contributors
  ) {
    key
    commits {
      aggregateVersion
      events
    }
  }
}
    `;

export function useOrderRatingMutation() {
  return Urql.useMutation<OrderRatingMutation, OrderRatingMutationVariables>(OrderRatingDocument);
};
export const AccountEligibleRatersDocument = /*#__PURE__*/ gql`
    query AccountEligibleRaters {
  accountEligibleRaters {
    users {
      id
      name
      email
      phone
    }
  }
}
    `;

export function useAccountEligibleRatersQuery(options?: Omit<Urql.UseQueryArgs<AccountEligibleRatersQueryVariables>, 'query'>) {
  return Urql.useQuery<AccountEligibleRatersQuery, AccountEligibleRatersQueryVariables>({ query: AccountEligibleRatersDocument, ...options });
};
export const RatingProfileNameAndDescriptionByIdDocument = /*#__PURE__*/ gql`
    query RatingProfileNameAndDescriptionById($ratingProfileId: Int!) {
  ratingProfile(id: $ratingProfileId) {
    id
    name
    description
  }
}
    `;

export function useRatingProfileNameAndDescriptionByIdQuery(options: Omit<Urql.UseQueryArgs<RatingProfileNameAndDescriptionByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingProfileNameAndDescriptionByIdQuery, RatingProfileNameAndDescriptionByIdQueryVariables>({ query: RatingProfileNameAndDescriptionByIdDocument, ...options });
};
export const RatingsOverviewDocument = /*#__PURE__*/ gql`
    subscription RatingsOverview($q: String, $filter: RatingStateFilter, $pagination: PaginationInput) {
  ratings(q: $q, filter: $filter, pagination: $pagination) {
    companyName
    orgNumber
    key
    contactPerson {
      id
      name
    }
    ratingProfileId
    ratingProfileDescription
    lastSignificantEventType
    lastSignificantEventAt
    pendingActionBy
    period {
      start
      end
    }
    ratingProfile {
      id
      name
      businessArea
      methodVersion
    }
    owner {
      id
      name
    }
  }
}
    `;

export function useRatingsOverviewSubscription<TData = RatingsOverviewSubscription>(options?: Omit<Urql.UseSubscriptionArgs<RatingsOverviewSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<RatingsOverviewSubscription, TData>) {
  return Urql.useSubscription<RatingsOverviewSubscription, TData, RatingsOverviewSubscriptionVariables>({ query: RatingsOverviewDocument, ...options }, handler);
};
export const RatingCountsDocument = /*#__PURE__*/ gql`
    subscription RatingCounts {
  ratingCounts {
    pendingBasis
    pendingControl
    completed
    cancelled
    free
  }
}
    `;

export function useRatingCountsSubscription<TData = RatingCountsSubscription>(options?: Omit<Urql.UseSubscriptionArgs<RatingCountsSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<RatingCountsSubscription, TData>) {
  return Urql.useSubscription<RatingCountsSubscription, TData, RatingCountsSubscriptionVariables>({ query: RatingCountsDocument, ...options }, handler);
};
export const ApproveAnomalyDocument = /*#__PURE__*/ gql`
    mutation ApproveAnomaly($ratingId: ID!, $anomalyId: ID!, $comment: String!) {
  approveAnomaly(ratingId: $ratingId, anomalyId: $anomalyId, comment: $comment)
}
    `;

export function useApproveAnomalyMutation() {
  return Urql.useMutation<ApproveAnomalyMutation, ApproveAnomalyMutationVariables>(ApproveAnomalyDocument);
};
export const UnapproveAnomalyDocument = /*#__PURE__*/ gql`
    mutation UnapproveAnomaly($ratingId: ID!, $anomalyId: ID!) {
  unapproveAnomaly(ratingId: $ratingId, anomalyId: $anomalyId)
}
    `;

export function useUnapproveAnomalyMutation() {
  return Urql.useMutation<UnapproveAnomalyMutation, UnapproveAnomalyMutationVariables>(UnapproveAnomalyDocument);
};
export const OmposteringDocument = /*#__PURE__*/ gql`
    mutation Ompostering($ratingId: ID!, $amount: Float!, $anomalyId: String!, $omposteringsRule: OmposteringsRule!) {
  ompostering(
    ratingId: $ratingId
    amount: $amount
    anomalyId: $anomalyId
    omposteringsRule: $omposteringsRule
  )
}
    `;

export function useOmposteringMutation() {
  return Urql.useMutation<OmposteringMutation, OmposteringMutationVariables>(OmposteringDocument);
};
export const RemoveAdditionalQuestionDocument = /*#__PURE__*/ gql`
    mutation RemoveAdditionalQuestion($ratingId: ID!, $id: ID!) {
  removeAdditionalQuestion(ratingId: $ratingId, id: $id)
}
    `;

export function useRemoveAdditionalQuestionMutation() {
  return Urql.useMutation<RemoveAdditionalQuestionMutation, RemoveAdditionalQuestionMutationVariables>(RemoveAdditionalQuestionDocument);
};
export const AddAdditionalQuestionDocument = /*#__PURE__*/ gql`
    mutation AddAdditionalQuestion($ratingId: ID!, $text: String!, $helpText: String, $textInput: Boolean!, $uploads: Boolean!) {
  addAdditionalQuestion(
    ratingId: $ratingId
    text: $text
    helpText: $helpText
    textInput: $textInput
    uploads: $uploads
  )
}
    `;

export function useAddAdditionalQuestionMutation() {
  return Urql.useMutation<AddAdditionalQuestionMutation, AddAdditionalQuestionMutationVariables>(AddAdditionalQuestionDocument);
};
export const RequestDocumentationAmendmentsDocument = /*#__PURE__*/ gql`
    mutation RequestDocumentationAmendments($ratingId: ID!, $message: String!, $scopes: [String!]!) {
  requestDocumentationAmendments(
    ratingId: $ratingId
    message: $message
    scopes: $scopes
  )
}
    `;

export function useRequestDocumentationAmendmentsMutation() {
  return Urql.useMutation<RequestDocumentationAmendmentsMutation, RequestDocumentationAmendmentsMutationVariables>(RequestDocumentationAmendmentsDocument);
};
export const CompleteRatingDocument = /*#__PURE__*/ gql`
    mutation CompleteRating($ratingId: ID!) {
  completeRating(ratingId: $ratingId)
}
    `;

export function useCompleteRatingMutation() {
  return Urql.useMutation<CompleteRatingMutation, CompleteRatingMutationVariables>(CompleteRatingDocument);
};
export const EditRatingCommentDocument = /*#__PURE__*/ gql`
    mutation EditRatingComment($ratingId: ID!, $comment: String!) {
  editRatingComment(ratingId: $ratingId, comment: $comment)
}
    `;

export function useEditRatingCommentMutation() {
  return Urql.useMutation<EditRatingCommentMutation, EditRatingCommentMutationVariables>(EditRatingCommentDocument);
};
export const ApproveKpiValueDocument = /*#__PURE__*/ gql`
    mutation ApproveKpiValue($ratingId: ID!, $kpiId: String!, $approved: Boolean) {
  approveKpiValue(ratingId: $ratingId, kpiId: $kpiId, approved: $approved)
}
    `;

export function useApproveKpiValueMutation() {
  return Urql.useMutation<ApproveKpiValueMutation, ApproveKpiValueMutationVariables>(ApproveKpiValueDocument);
};
export const SetRatingDatapointsDocument = /*#__PURE__*/ gql`
    mutation SetRatingDatapoints($ratingId: ID!, $datapoints: JSONObject!) {
  setRatingDatapoints(ratingId: $ratingId, datapoints: $datapoints)
}
    `;

export function useSetRatingDatapointsMutation() {
  return Urql.useMutation<SetRatingDatapointsMutation, SetRatingDatapointsMutationVariables>(SetRatingDatapointsDocument);
};
export const OverrideKpiValueDocument = /*#__PURE__*/ gql`
    mutation overrideKpiValue($ratingId: ID!, $kpiId: String!, $value: Float!, $oldValue: Float, $reason: String!) {
  overrideKpiValue(
    ratingId: $ratingId
    kpiId: $kpiId
    value: $value
    oldValue: $oldValue
    reason: $reason
  )
}
    `;

export function useOverrideKpiValueMutation() {
  return Urql.useMutation<OverrideKpiValueMutation, OverrideKpiValueMutationVariables>(OverrideKpiValueDocument);
};
export const RemoveKpiValueOverrideDocument = /*#__PURE__*/ gql`
    mutation removeKpiValueOverride($ratingId: ID!, $kpiId: String!) {
  removeKpiValueOverride(ratingId: $ratingId, kpiId: $kpiId)
}
    `;

export function useRemoveKpiValueOverrideMutation() {
  return Urql.useMutation<RemoveKpiValueOverrideMutation, RemoveKpiValueOverrideMutationVariables>(RemoveKpiValueOverrideDocument);
};
export const RatingCommitsDocument = /*#__PURE__*/ gql`
    query RatingCommits($key: String!) {
  rating(key: $key) {
    key
    commits {
      aggregateVersion
      timestamp
      events
    }
  }
}
    `;

export function useRatingCommitsQuery(options: Omit<Urql.UseQueryArgs<RatingCommitsQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingCommitsQuery, RatingCommitsQueryVariables>({ query: RatingCommitsDocument, ...options });
};
export const ChangeRatingPeriodDocument = /*#__PURE__*/ gql`
    mutation ChangeRatingPeriod($ratingId: ID!, $startYear: Int!, $startMonth: Int!, $endYear: Int!, $endMonth: Int!) {
  changeRatingPeriod(
    ratingId: $ratingId
    startYear: $startYear
    startMonth: $startMonth
    endYear: $endYear
    endMonth: $endMonth
  )
}
    `;

export function useChangeRatingPeriodMutation() {
  return Urql.useMutation<ChangeRatingPeriodMutation, ChangeRatingPeriodMutationVariables>(ChangeRatingPeriodDocument);
};
export const ChangeRatingProfileDocument = /*#__PURE__*/ gql`
    mutation ChangeRatingProfile($ratingId: ID!, $ratingProfileId: Int!) {
  changeRatingProfile(ratingId: $ratingId, ratingProfileId: $ratingProfileId)
}
    `;

export function useChangeRatingProfileMutation() {
  return Urql.useMutation<ChangeRatingProfileMutation, ChangeRatingProfileMutationVariables>(ChangeRatingProfileDocument);
};
export const EditRatingContactDocument = /*#__PURE__*/ gql`
    mutation EditRatingContact($ratingId: ID!, $name: String!, $phone: String!, $email: String!) {
  editRatingContact(
    ratingId: $ratingId
    name: $name
    phone: $phone
    email: $email
  )
}
    `;

export function useEditRatingContactMutation() {
  return Urql.useMutation<EditRatingContactMutation, EditRatingContactMutationVariables>(EditRatingContactDocument);
};
export const RatingContributorsDocument = /*#__PURE__*/ gql`
    query RatingContributors($key: String!) {
  ratingContributors(key: $key) {
    owner {
      id
      name
      email
      phone
    }
    raters {
      id
      name
      email
      phone
    }
    contributors {
      id
      name
      email
      phone
    }
    contactPerson {
      id
      name
      email
      phone
    }
  }
}
    `;

export function useRatingContributorsQuery(options: Omit<Urql.UseQueryArgs<RatingContributorsQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingContributorsQuery, RatingContributorsQueryVariables>({ query: RatingContributorsDocument, ...options });
};
export const ChangeRatingRatersDocument = /*#__PURE__*/ gql`
    mutation ChangeRatingRaters($ratingId: ID!, $raterUserIds: [Int!]!) {
  changeRatingRaters(ratingId: $ratingId, raterUserIds: $raterUserIds)
}
    `;

export function useChangeRatingRatersMutation() {
  return Urql.useMutation<ChangeRatingRatersMutation, ChangeRatingRatersMutationVariables>(ChangeRatingRatersDocument);
};
export const ChangeRatingContactPersonsDocument = /*#__PURE__*/ gql`
    mutation ChangeRatingContactPersons($ratingId: ID!, $removedUserIds: [Int!]!, $addedContacts: [MinimalContactInfo!]!) {
  changeRatingContactPersons(
    ratingId: $ratingId
    removedUserIds: $removedUserIds
    addedContacts: $addedContacts
  )
}
    `;

export function useChangeRatingContactPersonsMutation() {
  return Urql.useMutation<ChangeRatingContactPersonsMutation, ChangeRatingContactPersonsMutationVariables>(ChangeRatingContactPersonsDocument);
};
export const RatingReportHistoryDocument = /*#__PURE__*/ gql`
    query RatingReportHistory($key: String!) {
  ratingReportHistory(key: $key) {
    pdfReportKey
    createdAt
  }
}
    `;

export function useRatingReportHistoryQuery(options: Omit<Urql.UseQueryArgs<RatingReportHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<RatingReportHistoryQuery, RatingReportHistoryQueryVariables>({ query: RatingReportHistoryDocument, ...options });
};
export const RegenerateReportDocument = /*#__PURE__*/ gql`
    mutation RegenerateReport($ratingId: ID!) {
  regenerateReport(ratingId: $ratingId)
}
    `;

export function useRegenerateReportMutation() {
  return Urql.useMutation<RegenerateReportMutation, RegenerateReportMutationVariables>(RegenerateReportDocument);
};